<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path fill="none" d="M0 0h48v48H0z" />
    <path
      d="M8 32c0 2.2 1.8 4 4 4h2a4 4 0 0 0 8 0h7a4 4 0 0 0 8 0h3V24l-4-8h-4v-4c0-2.2-1.8-4-4-4H12c-2.2 0-4 1.8-4 4v20zm26 4c0 .551-.449 1-1 1s-1-.449-1-1 .449-1 1-1 1 .449 1 1zm-16 1c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zm16.146-18L37 24.708V26h-1c-2.2 0-4-1.8-4-4v-3h2.146z"
    />
  </svg>
</template>